module.exports = __webpack_public_path__ + "static/media/linear-bg.6259ed7c.svg";